import { Form, Modal, Select, message } from "antd";
import { useForm } from "antd/lib/form/Form";
import { formatError } from "common/redux/middleware/queryErrorLogger";
import { useGeneratePaymentReceiptMutation } from "features/payments/paymentsAPI";
import { useFetchLetterTemplatesQuery } from "features/letterTemplates/letterTemplatesAPI";
import styled from "styled-components";

const StyledForm = styled(Form)`
  margin-top: 12px;
  max-width: 350px;
`;

export default function GeneratePaymentReceiptModal({ open, onOk, onCancel, paymentIntentId }) {
  const [form] = useForm();
  const { data: letterTemplates, isLoading: isLoadingLetterTemplates } =
    useFetchLetterTemplatesQuery();
  const [generateReceipt, { isLoading: isGeneratingReceipt }] = useGeneratePaymentReceiptMutation();

  const paymentReceiptTemplates = letterTemplates?.filter(
    (template) => template.type === "payment_receipts",
  );

  const onSubmit = async () => {
    const values = await form.validateFields();
    const { letterTemplateId } = values;

    const result = await generateReceipt({
      paymentIntentId,
      letterTemplateId,
    });

    if ("data" in result) {
      await onOk();
      form.resetFields();
      return message.success("Receipt downloaded successfully");
    }
    if ("error" in result) {
      form.setFields(formatError(result.error));
      message.error("Failed to generate receipt");
    }
  };

  return (
    <Modal
      maskClosable={false}
      title="Generate Payment Receipt"
      open={open}
      confirmLoading={isGeneratingReceipt}
      onOk={onSubmit}
      onCancel={onCancel}
      okText="Generate"
    >
      <StyledForm layout="vertical" form={form} disabled={isGeneratingReceipt}>
        <Form.Item
          label="Receipt Template"
          name="letterTemplateId"
          rules={[{ required: true, message: "Please select a receipt template" }]}
        >
          <Select
            loading={isLoadingLetterTemplates}
            placeholder="Select Receipt Template..."
            disabled={isGeneratingReceipt}
            popupMatchSelectWidth={false}
            allowClear
            maxTagTextLength={20}
            options={paymentReceiptTemplates?.map((template) => ({
              value: template.id,
              label: template.filename,
            }))}
          />
        </Form.Item>
      </StyledForm>
    </Modal>
  );
}
